import React from "react";
import CrashSite from "../modules/CrashSite";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Application crashed:", error, errorInfo);

    this.setState({
      error,
      errorInfo
    });

    // TODO: send to backend logging API
  }

  render() {
    if (this.state.hasError) {
      return (
        <CrashSite
          error={this.state.error}
          errorInfo={this.state.errorInfo}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
